import { apiRequest } from './index';

export const fetchPositionRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/positions/' + id, {}, success, failure);
}

export const fetchPositionsRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/positions', {}, success, failure);
}

export const createPositionRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/positions',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editPositionRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/positions/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

const buildPositionOptions = position => ({
    value: position ? position._id : '',
    label: position ? position.positionName : '',
    data: position
});

export const positionSelectOptionRequest = (success = (result = []) => {}, failure = (error) => {}) =>{
    fetch(process.env.REACT_APP_API_ENDPOINT + '/positions')
        .then(response => response.json())
        .then(data => {
            const selectOptions = [];
            data.forEach((item) => {
                const option = buildPositionOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error.status);
        });
}

export const deletePositionRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/positions/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
